export const formatMoney = (amount) => {

    let price = Intl.NumberFormat('en-MX', { style: "currency", currency: 'MXN' });

    return price.format(amount)
    
}